// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDcvSbznu-t6bzC23_ECTpPp1H7ZQ-1ruE",
  authDomain: "habitop-6bb41.firebaseapp.com",
  projectId: "habitop-6bb41",
  storageBucket: "habitop-6bb41.appspot.com",
  messagingSenderId: "624293411606",
  appId: "1:624293411606:web:cf375612196f225596ae37",
  measurementId: "G-XXXXXXXXXX"
};

// Log para debug em desenvolvimento
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase Config:', {
    apiKey: firebaseConfig.apiKey ? 'Definido' : 'Não definido',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    storageBucket: firebaseConfig.storageBucket,
    messagingSenderId: firebaseConfig.messagingSenderId,
    appId: firebaseConfig.appId ? 'Definido' : 'Não definido'
  });
}

export default firebaseConfig; 